import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// FLATBUFFER ENUMS
import { AttributeId } from "../../../../../flatbuffers/generated/opc-ua/attribute-id";
// COMPONENTS
import OpcUaFieldLabel from "./OpcUaFieldLabel";

const { Option } = Select;

/** Human-readable labels for the generated AttributeId enum (OPC UA Part 6). */
const ATTRIBUTE_OPTIONS: { value: AttributeId; label: string }[] = [
  { value: AttributeId.NodeId, label: "NodeId" },
  { value: AttributeId.NodeClass, label: "NodeClass" },
  { value: AttributeId.BrowseName, label: "BrowseName" },
  { value: AttributeId.DisplayName, label: "DisplayName" },
  { value: AttributeId.Description, label: "Description" },
  { value: AttributeId.WriteMask, label: "WriteMask" },
  { value: AttributeId.UserWriteMask, label: "UserWriteMask" },
  { value: AttributeId.IsAbstract, label: "IsAbstract" },
  { value: AttributeId.Symmetric, label: "Symmetric" },
  { value: AttributeId.InverseName, label: "InverseName" },
  { value: AttributeId.ContainsNoLoops, label: "ContainsNoLoops" },
  { value: AttributeId.EventNotifier, label: "EventNotifier" },
  { value: AttributeId.Value, label: "Value" },
  { value: AttributeId.DataType, label: "DataType" },
  { value: AttributeId.ValueRank, label: "ValueRank" },
  { value: AttributeId.ArrayDimensions, label: "ArrayDimensions" },
  { value: AttributeId.AccessLevel, label: "AccessLevel" },
  { value: AttributeId.UserAccessLevel, label: "UserAccessLevel" },
  { value: AttributeId.MinimumSamplingInterval, label: "MinimumSamplingInterval" },
  { value: AttributeId.Historizing, label: "Historizing" },
  { value: AttributeId.Executable, label: "Executable" },
  { value: AttributeId.UserExecutable, label: "UserExecutable" },
  { value: AttributeId.DataTypeDefinition, label: "DataTypeDefinition" },
  { value: AttributeId.RolePermissions, label: "RolePermissions" },
  { value: AttributeId.UserRolePermissions, label: "UserRolePermissions" },
  { value: AttributeId.AccessRestrictions, label: "AccessRestrictions" },
  { value: AttributeId.AccessLevelEx, label: "AccessLevelEx" },
];

/** Human-readable label for an AttributeId value — the same table the picker renders, reused so a stored row can show "DisplayName" instead of the raw enum number. */
export function attributeLabel(value: AttributeId): string {
  return ATTRIBUTE_OPTIONS.find((opt) => opt.value === value)?.label ?? String(value);
}

/** Shared picker for the generated AttributeId enum (defaults to Value across every editor that reads/writes a node). */
export default function AttributeSelect({
  value,
  onChange,
  label = "Attribute",
  tooltip = undefined,
  disabled = false,
}: {
  value: AttributeId;
  onChange: (value: AttributeId) => void;
  label?: string;
  tooltip?: React.ReactNode;
  disabled?: boolean;
}) {
  return (
    <div>
      <OpcUaFieldLabel label={label} tooltip={tooltip} />
      <Select
        className="generalStyles__width100"
        size="large"
        style={{ width: "100%", marginTop: 8 }}
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        {ATTRIBUTE_OPTIONS.map((opt) => (
          <Option key={opt.value} value={opt.value}>
            {opt.label}
          </Option>
        ))}
      </Select>
    </div>
  );
}
